import React, { FunctionComponent } from 'react';

interface Props {
    children: any;
}

const FilterPageContent: FunctionComponent<Props> = ({ children }) => {

    return (
        <div className={'filter-page__content'}>
            { children }
        </div>
    );
};

export default FilterPageContent;
